import { createFileRoute, redirect } from "@tanstack/react-router";

/** `/birdie` → `/birdie/sessions`, the monitor's one page. */
export const Route = createFileRoute("/birdie/")({
  beforeLoad: () => {
    throw redirect({ to: "/birdie/sessions" });
  },
});
